module.exports = "https://static.wmbcdn.com/uniweb/images/92cd0a199b4ad27b18fb6dfc529abf82.svg";